import { render, staticRenderFns } from "./admin_journal.vue?vue&type=template&id=37910cd6&"
import script from "./admin_journal.vue?vue&type=script&lang=js&"
export * from "./admin_journal.vue?vue&type=script&lang=js&"
import style0 from "./admin_journal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports